import { useState } from 'react';

export default function ContactSection() {
  const [showFeedback, setShowFeedback] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== '') return;
    setShowFeedback(true);
    setTimeout(() => setShowFeedback(false), 3000);
    form.reset();
  };

  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              有好的国产电影推荐？欢迎通过下方留言，编辑团队会认真评估每一条推荐
            </p>
          </div>

          <form
            onSubmit={handleSubmit}
            action="https://readdy.ai/api/form/d9kvo1ghpes2mi34ssd0"
            method="POST"
            data-readdy-form
            className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 space-y-5"
          >
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />

            <div>
              <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                你的昵称
              </label>
              <input
                id="contact-name"
                name="name"
                type="text"
                required
                placeholder="请输入昵称"
                className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              />
            </div>

            <div>
              <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                电子邮箱
              </label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                placeholder="请输入邮箱地址"
                className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
              />
            </div>

            <div>
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                推荐或咨询内容
              </label>
              <textarea
                id="contact-message"
                name="message"
                required
                rows={4}
                maxLength={500}
                placeholder="请描述你想推荐的好电影或咨询的问题..."
                className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
              ></textarea>
              <p className="mt-1 text-xs text-foreground-500">最多500字</p>
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              发送留言
            </button>

            {showFeedback && (
              <div className="text-center py-3 bg-accent-100 text-accent-800 text-sm rounded-lg">
                感谢你的留言！我们会认真查看每一条推荐。
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}